import { Switch, type SwitchProps } from '@/ui';

/**
 * The customize panels' toggle, as the trailing control in a SidebarRow. Spread
 * `registerToggle(scope, field)` onto it and it reports the saved value and
 * persists a click.
 *
 * Unlike the panels' value controls it does not preview on hover, by design —
 * see `registerToggle`.
 */
export const SidebarRowSwitch = (props: SwitchProps) => (
  <Switch colorScheme="brand" {...props} />
);
